'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	(0, _jquery2.default)('select:not([data-select2="false"])', this).each(function (i, item) {
		var $item = (0, _jquery2.default)(item);

		if ($item.attr("data-select2") !== "false") {
			initSelect2($item);
		}
		// extra($item);
	});
};

exports.initSelect2 = initSelect2;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _odataUri = require('../utils/odata-uri');

var _odataUri2 = _interopRequireDefault(_odataUri);

var _querystring = require('../utils/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _event = require('../core/event');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var odataPageSize = 20;

// set global default values
_jquery2.default.fn.select2.defaults.set("minimumResultsForSearch", 10);
_jquery2.default.fn.select2.defaults.set("dropdownAutoWidth", true);
_jquery2.default.fn.select2.defaults.set("escapeMarkup", function (markup) {
	return markup;
});

;

function initSelect2($item) {
	var options = {};
	if ($item.attr("data-options")) {
		options = JSON.parse($item.attr("data-options"));
	}

	if ($item.is('[data-ajax--url],[data-ajax-url]')) {
		options.ajax = ajaxOptions($item);
		options.escapeMarkup = escapeMarkup;
	}
	if ($item.attr("multiple") == "multiple") {
		multiSelect($item, options);
	}
	options.templateResult = function (data) {
		var result = formatItem(data);
		var params = { item: $item, result: result, data: data };
		(0, _event.trigger)('linksoft.select2.renderingTemplate', params);
		return params.result;
	};
	options.templateSelection = function (data) {
		var result = formatSelectedItem(data);
		var params = { item: $item, result: result, data: data };
		(0, _event.trigger)('linksoft.select2.renderingTemplateSelection', params);
		return params.result;
	};
	$item.select2(options);
}

function extract_preselected_ids(element) {
	var preselected_ids = [];
	if (element.attr("value")) (0, _jquery2.default)(element.attr("value").split(",")).each(function () {
		preselected_ids.push({ id: this });
	});
	return preselected_ids;
}

function preSelect(preselected_ids, selections) {
	var pre_selections = [];
	selections.forEach(function (s) {
		preselected_ids.forEach(function (ps) {
			// for (var id_index in )
			if (s.id === ps.id) {
				pre_selections.push(s);
			}
		});
	});
	return pre_selections;
}

function multiSelect($item, options) {
	if ($item.attr("data-selections")) {
		var selections = JSON.parse($item.attr("data-selections"));

		var preselected = extract_preselected_ids($item);
		$item.find("option").each(function () {
			var _this = this;

			preselected.forEach(function (el) {
				if (el.id == (0, _jquery2.default)(_this).attr("value")) {
					(0, _jquery2.default)(_this).attr("selected", "selected");
				}
			});
		});

		options.data = function () {
			return { results: selections };
		};
		options.initSelection = function (element, callback) {
			var preselected_ids = extract_preselected_ids(element); //1,3,4 are the pre-selected IDs as per HTML attributes
			var preSelections = preSelect(preselected_ids, selections);
			callback(preSelections);
		};
	}
}

function escapeMarkup(markup) {
	return markup;
}

function ajaxOptions($item) {
	if (!$item.is('[data-odata="false"]')) return odataOptions($item);

	var textStorage = $item.attr('data-text') || 'name';
	var text2Storage = $item.attr('data-text2') || 'text2';
	var text3Storage = $item.attr('data-text3') || 'text3';
	return {
		dataType: 'json',
		cache: true,
		type: 'POST',
		delay: 400,
		transport: function transport(params, success, failure) {
			params.item = $item;
			(0, _event.trigger)('linksoft.select2.transporting', params);
			var $request = (0, _ajax2.default)(params);
			$request.then(success);
			$request.fail(failure);
			return $request;
		},
		data: function data(e) {
			return JSON.stringify({ filter: e.term, page: e.page }); //$.extend({}, { filter: term.term, page: page });
		},
		processResults: function processResults(data, params) {
			// parse the results into the format expected by Select2
			// since we are using custom formatting functions we do not need to
			// alter the remote JSON data, except to indicate that infinite
			// scrolling can be used
			params.page = params.page || 1;
			return {
				results: data.results.map(function (r) {
					return {
						id: r.id,
						text: (0, _get3.default)(r, textStorage),
						text2: (0, _get3.default)(r, text2Storage),
						text3: (0, _get3.default)(r, text3Storage)
					};
				}),
				pagination: {
					more: params.page * (data.pageSize || odataPageSize) < data.totalCount
				}
			};
		}
	};
}

function odataOptions($item) {
	var selectFields = [$item.attr('data-id') || 'id', $item.attr('data-text') || 'name', $item.attr('data-text2'), $item.attr('data-text3')].filter(function (v) {
		return v;
	});
	var additionalSelectFieldsAttribute = $item.attr('data-additional-select-fields');
	if (additionalSelectFieldsAttribute) {
		var additionalSelectFields = additionalSelectFieldsAttribute.split(',');
		selectFields = selectFields.concat(additionalSelectFields);
	}
	var orderBy = [{ property: $item.attr('data-order-by') || 'name', dir: $item.attr('data-order-dir') || 'asc' }];

	var pageSize = parseInt($item.attr('data-page-size') || '' + odataPageSize, 10);

	return {
		dataType: 'json',
		cache: true,
		type: 'GET',
		delay: 400,
		transport: function transport(params, success, failure) {
			params.item = $item;
			(0, _event.trigger)('linksoft.select2.transporting', params);
			var $request = (0, _ajax2.default)(params);
			$request.then(success);
			$request.fail(failure);
			return $request;
		},
		data: function data(e) {
			var filter = [];
			var customFilter = processCustomFilter($item.attr('data-odata-filter'));
			if (customFilter) {
				filter.push(customFilter);
			}

			// if (customFilter) {
			// 	if ($item.is('[data-odata-filter-args]')) {
			// 		const customFilterArgs = $($item.attr('data-odata-filter-args')).toArray().forEach(el => $(el).val());
			// 		customFilter = customFilter.replace(/{([^}]+)}/g, function (match, i) {
			// 			const argument = customFilterArgs[i];
			// 			return typeof argument != 'undefined' ? argument : match;
			// 		});
			// 	}
			// 	filter.push(customFilter);
			// }
			//
			// const customFilterFunc = $item.attr('data-filter-func');
			// if (customFilterFunc) {
			// 	const filterFunc = window[customFilterFunc];
			// 	if (typeof filterFunc === 'function') {
			// 		const filterFuncResult = filterFunc();
			// 		if (filterFuncResult) {
			// 			filter.push(filterFuncResult);
			// 		}
			// 	}
			// }

			if (typeof e.term === 'string' && e.term.length > 0) {
				var searchIn = ($item.attr('data-search-in') || 'name').split(',');
				filter.push(_odataUri.filters.or(searchIn.map(function (field) {
					return _odataUri.filters.contains(field, e.term);
				})));
			}
			var skip = ((e.page || 1) - 1) * pageSize;
			var oDataParams = (0, _odataUri2.default)(filter, orderBy, skip, pageSize, selectFields);
			(0, _event.trigger)('linksoft.select2.buildingUrlParams', { item: $item, params: oDataParams });
			return _querystring2.default.stringify(oDataParams);
		},
		processResults: function processResults(data, params) {
			// parse the results into the format expected by Select2
			// since we are using custom formatting functions we do not need to
			// alter the remote JSON data, except to indicate that infinite
			// scrolling can be used
			params.page = params.page || 1;
			var result = {
				results: data.value.map(function (r) {
					return {
						id: r.id,
						text: (0, _get3.default)(r, selectFields[1]),
						text2: (0, _get3.default)(r, selectFields[2]),
						text3: (0, _get3.default)(r, selectFields[3])
					};
				}),
				pagination: {
					more: params.page * (data.pageSize || pageSize) < data["@odata.count"]
				}
			};
			(0, _event.trigger)('linksoft.select2.processingResults', { item: $item, data: data, result: result });
			return result;
		}
	};
}

function processCustomFilter(customFilter) {
	if (typeof customFilter === 'string') {
		return customFilter.replace(/{([^}]+)}/g, function (match, selector) {
			return (0, _jquery2.default)(selector).val() || '';
		});
	}
	return null;
}

function formatItem(item) {
	if (item.loading) return item.text;
	var img = item.imageUrl ? '<img src="' + item.imageUrl + '" alt="' + image.text + '" />' : '';
	var text = '<span class="text">' + item.text + '</span>';
	var text2 = item.text2 ? '<span class="text2">' + item.text2 + '</span>' : '';
	var text3 = item.text3 ? '<span class="text3">' + item.text3 + '</span>' : '';
	return img + text + text2 + text3;
	//var rv = item.css ? "<span class=\"" + item.css + "\">" + item.text : item.text;
	//var ta = item.textAdditional;
	//if (!ta && item.element) {
	//    ta = $(item.element).attr("data-text-additional2") || $(item.element).attr("data-text-additional");
	//}
	//if (ta) {
	//    rv += "<span class=\"text-additional\">" + ta + "</span>";
	//}
	//return item.css ? rv + "</span>" : rv;
}

function formatSelectedItem(item) {
	var label = (0, _jquery2.default)(item.element).parent("optgroup").attr("label");
	return label ? label + ": " + item.text : item.text;
	//var rv = item.css ? "<span class=\"" + item.css + "\">" + item.text : item.text;
	//var ta = item.textAdditional;
	//if (!ta && item.element) {
	//    ta = $(item.element).attr("data-text-additional");
	//}
	//if (this.element) {
	//    var copyto = this.element.data("select2-copyto");
	//    if (copyto && copyto.destinations) {
	//        var copytosrc = item[copyto.source];
	//        if (copytosrc) {
	//            var $target = $(this.element);
	//            $target.data("ls-copy-from", false);
	//            for (var i = 0; i < copyto.destinations.length; i++) {
	//                var destination = copyto.destinations[i];
	//                var target = $(destination.target);
	//                var targVal = copytosrc[destination.field];
	//                if (target.is(":input")) {
	//                    var curval = target.val();
	//                    if (curval != targVal) {
	//                        target.val(targVal);
	//                        target.trigger("change");
	//                    }
	//                } else {
	//                    target.text(targVal);
	//                }
	//            }
	//            $target.data("ls-copy-from", true);
	//        }
	//    }
	//}
	//if (ta) {
	//    rv += "<span class=\"text-additional\">" + ta + "</span>";
	//}
	//return item.css ? rv + "</span>" : rv;
}

function onRelatedChanged($item) {
	return function (a, b, c, d) {
		var valueToProcess, liToProcess, mainOption;
		var data = (0, _jquery2.default)(this).data("select2");
		var container = data.container;
		var items = (0, _jquery2.default)("li.select2-search-choice", container);
		if (a.added) {
			// add new value
			for (var i = 0; i < a.added.element.length; i++) {
				valueToProcess = a.added.element[i].value;
				mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
					return el.value == valueToProcess;
				});
				if (mainOption.length == 0) {
					mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
					$item.append(mainOption);
				}
				mainOption = mainOption[0];
				liToProcess = null;
				for (var j = 0; j < items.length; j++) {
					liToProcess = (0, _jquery2.default)(items[j]);
					if ((0, _jquery2.default)(items[j]).data("select2-data").id === valueToProcess) {
						liToProcess.css("padding-right", "+=15");
						var $a = (0, _jquery2.default)("<a tabindex=\"-1\" href=\"#\" class=\"" + (mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off") + "\"></a>");
						liToProcess.append($a);
						liToProcess.data("select2-extra", true);
						$a.click(function (e) {
							var valueToProcess = (0, _jquery2.default)(this).closest("li").data("select2-data").id;
							var mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
								return el.value == valueToProcess;
							});
							if (mainOption.length == 0) {
								mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
								$item.append(mainOption);
							}
							mainOption = mainOption[0];
							mainOption.selected = !mainOption.selected;
							$item.trigger("change");
							(0, _jquery2.default)(this).attr("class", mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off");
							e.preventDefault();
							e.stopImmediatePropagation();
						});
						break;
					}
				}
			}
		}
		if (a.removed) {
			// remove value
			for (var i = 0; i < a.removed.element.length; i++) {
				valueToProcess = a.removed.element[i].value;
				mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
					return el.value == valueToProcess;
				});

				if (mainOption.length != 0) {
					mainOption[0].selected = false;
				}
			}
		}
		if (!(a.added || a.removed)) {
			// original select changed
			init(items);
		}
	};
}

//function initSelection(element, callback) {
//    var $e = $(element);
//    var init = $e.data("select2-initial");
//    if (init === 'set_value') {
//        var value = $e.val();
//
//        var uri = new Uri(url).query(function (qs) {
//            delete qs.selectedIds;
//            delete qs.filter;
//            delete qs.pageNum;
//            delete qs.allowEmpty;
//            forOwn(function (v, k) {
//                if (k.startsWith("selectedIds")) delete qs[k];
//            });
//        });
//        var ajax = {
//            url: uri.toString(),
//            dataType: 'jsonp',
//            type: "POST",
//            data: {selectedIds: value},
//            success: function (d, page) {
//                if (d.results) {
//                    var x = [];
//                    for (var i = 0; i < d.results.length; i++) {
//                        if (!d.results[i].selected) continue;
//                        x.push(d.results[i]);
//                    }
//                    callback(x);
//                }
//            }
//        }
//        $.ajax(ajax);
//
//    } else {
//        $e.data("select2-initial", 'set_value'); // next time this is called, it's after a $element.select2('val', ...)
//    }
//    if (init) {
//        callback(init);
//    }
//}

function extra($item) {
	if ($item.attr("data-select2-extra") != null) {
		var $related = (0, _jquery2.default)($item.attr("data-select2-extra"));
		if (!$related.data("select2")) {
			throw new Error("select2 extra can be called only on select2 object");
		}

		var init = function init(items) {
			var liToProcess = null;
			for (var j = 0; j < items.length; j++) {
				liToProcess = (0, _jquery2.default)(items[j]);
				var valueToProcess = (0, _jquery2.default)(items[j]).data("select2-data").id;
				var mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
					return el.value === valueToProcess;
				});
				if (mainOption.length === 0) {
					mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
					$item.append(mainOption);
				}
				mainOption = mainOption[0];
				if (!liToProcess.data("select2-extra")) {
					liToProcess.css("padding-right", "+=15");
					var $a = (0, _jquery2.default)("<a tabindex=\"-1\" href=\"#\" class=\"" + (mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off") + "\"></a>");
					liToProcess.append($a);
					$a.click(function (e) {
						var valueToProcess = (0, _jquery2.default)(this).closest("li").data("select2-data").id;
						var mainOption = (0, _jquery2.default)("option", $item).filter(function (i, el) {
							return el.value == valueToProcess;
						});
						if (mainOption.length == 0) {
							mainOption = (0, _jquery2.default)("<option></option>").val(valueToProcess).text(a.added.element[i].text);
							$item.append(mainOption);
						}
						mainOption = mainOption[0];
						mainOption.selected = !mainOption.selected;
						$item.trigger("change");
						(0, _jquery2.default)(this).attr("class", mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off");
						e.preventDefault();
						e.stopImmediatePropagation();
					});
				} else {
					(0, _jquery2.default)("a.select2-search-choice-extra-on, a.select2-search-choice-extra-off", liToProcess).attr("class", mainOption.selected ? "select2-search-choice-extra-on" : "select2-search-choice-extra-off");
				}
				liToProcess.data("select2-extra", true);
			}
		};

		$related.change(onRelatedChanged($item));

		var relatedData = $related.data("select2");
		var container = relatedData.container;
		var items = (0, _jquery2.default)("li.select2-search-choice", container);
		init(items);
		$item.data("select2").container.hide();
		$item.change(function () {
			var $related = (0, _jquery2.default)($item.attr("data-select2-extra"));
			var data = $related.data("select2");
			var container = data.container;
			var items = (0, _jquery2.default)("li.select2-search-choice", container);
			init(items);
		});
	}
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/select2.js
// module id = 499
// module chunks = 0